
















import { Vue, Component, Prop, PropSync, Ref } from 'vue-property-decorator'
import PullAndScroll from 'components/PullAndScroll.vue'
import ContentFolder from 'components/presenter/item/folder/Content.vue'
import ContentCourse from 'components/presenter/item/course/Content.vue'
import ContentTopic from 'components/presenter/item/topic/Content.vue'
import { Item, ItemType } from 'src/graphql/types'

@Component({
  components: {
    ContentFolder,
    ContentCourse,
    ContentTopic
  }
})
export default class PagePresenterItemContent extends Vue {
  ItemType = ItemType

  @Ref()
  readonly content!: PullAndScroll

  @Prop()
  readonly item!: Item

  @PropSync('loaderDisable')
  loaderDisableSync!: boolean

  async refresh (done: () => void) {
    await this.content.refresh(done)
  }

  async load (index: number, done: (stop?: boolean) => void) {
    await this.content.load(index, done)
  }
}
